import ConfigurationService from "src/services/configurationService";
import { Configuration } from "src/types/configuration";
import CalculationService from "src/services/calculationService";

const useConfigurationService = (
  initConfiguration: Configuration,
  calculationService: CalculationService,
) => {
  return new ConfigurationService(initConfiguration, calculationService);
};

export default useConfigurationService;
